import { GridActionsCellItem, GridColDef, GridColumnGroup } from "@mui/x-data-grid";
import { RenderHeader } from "./tableHeader";
import { ChartDataProps } from "../../graficos";
import { generateRandomHash } from "../../../core";
import { Delete } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

interface TableColsProps {
  dados: { [key: string]: string | number; }[];
  width?: number;

  styles: ChartDataProps[];

  onRemoveCol?: (colName: string) => void;
  onRemoveRow?: (id: string) => void;

  onAddCol?: () => void;
  onAddRow?: () => void;

  onTitleChange?: (field: string, title: string) => void;
  onStyleChange?: (field: string, style: ChartDataProps) => void;
}

export const generateTableCols = (dataProps: TableColsProps) => {
  const { width, onRemoveCol, onTitleChange, onStyleChange, onRemoveRow, onAddCol, onAddRow, styles } = dataProps;
  let { dados } = dataProps;

  if (dados.length === 0) return [];

  // Removendo a coluna ID anterior e adicionando a coluna X caso necessário
  dados = dados.map((data, i) => {
    const newData = { ...data };
    if (!newData["x"]) newData["x"] = i;

    return newData;
  });


  // Ajustando os dados para encaixar na tabela
  const columnsAdd: GridColDef[] = [];

  for (const item of dados) {
    for (const key in item) {
      const contains = columnsAdd.some((data) => data.field === key);
      if (!contains) {
        columnsAdd.push({
          field: key,
          headerName: key,
          type: key === "x" ? "custom" : "number",
          width: key === "x" ? 56 : width,
          minWidth: key === "x" ? 56 : width,
          hideable: key === "x" ? false : undefined,
          resizable: key === "x" ? false : undefined,
          groupable: key === "x" ? false : undefined,
          filterable: key === "x" ? false : undefined,
          disableColumnMenu: key === "x" ? true : undefined,
          sortable: false,
          editable: true,
          align: "center",
          renderHeader: key === "x" ? undefined : (params) => {
            return <RenderHeader
              onRemove={onRemoveCol}
              params={params}
              onTitleChange={onTitleChange}
              onStyleChange={onStyleChange}
              style={styles.filter((data) => data.dataKey === key)[0]}
            />;
          },
        });
      }
    }
  }


  // Adicionando o item editável
  let contains = columnsAdd.some((data) => data.field === "edit");
  let index = 0;
  while (contains) {
    contains = columnsAdd.some((data) => data.field === `edit${index > 0 ? index : ''}`);
    index++;
  }
  columnsAdd.unshift({
    field: `edit${index > 0 ? index : ''}`,
    headerName: "options",
    type: "actions",
    width: 124,
    editable: false,
    resizable: false,
    getActions: (row) => {
      return [
        <GridActionsCellItem
          key={1}
          icon={
            <Tooltip title="Remover Linha" >
              <Delete />
            </Tooltip >
          }
          label="Remover"
          onClick={onRemoveRow ? () => onRemoveRow(row.id.toString()) : undefined}
        />
      ];
    },
    renderHeader: (params) => {
      return <RenderHeader
        isOptions
        params={params}
        onAdd={onAddCol}
        onAddRow={onAddRow}
      />;
    },
  });

  return columnsAdd;
};

interface TableDataProps {
  dados: { [key: string]: string | number; }[];
}
export const generateTableData = (dataProps: TableDataProps) => {
  const { dados } = dataProps;

  const columns: string[] = [];
  for (const dado of dados) {
    for (const key in dado) {
      if (!columns.includes(key)) {
        columns.push(key);
      }
    }
  }

  // Criando a coluna do index
  let rowIdNow = "id";
  let contains = columns.some((data) => data === "id");
  let index = 0;
  while (contains) {
    contains = columns.some((data) => data === `id${index > 0 ? index : ''}`);
    index++;
    rowIdNow = `id${index}`;
  }

  const newData = dados.map((data) => {
    const newData = { ...data };
    newData[rowIdNow] = generateRandomHash(5);
    return newData;
  });

  return {
    id: rowIdNow,
    dados: newData,
  };
};

interface TableGroupProps {
  dados: ChartDataProps[];
}
export const generateTableGroups = ({ dados }: TableGroupProps) => {
  const groups: GridColumnGroup[] = [];
  const ids: { [key: string]: string[]; } = {};

  for (const dado of dados) {
    if (dado.stackId) {
      if (!ids[dado.stackId]) ids[dado.stackId] = [];
      ids[dado.stackId].push(dado.dataKey);
    }
  }

  for (const id in ids) {
    const stacks = ids[id];
    groups.push({
      groupId: id,
      freeReordering: true,
      children: stacks.map((stack) => { return { field: stack }; }),
    });
  }

  return groups;
};